import { TileLayer } from '@deck.gl/geo-layers';
import { parse } from '@loaders.gl/core';

import { geoBbox } from './tileBbox';
import { renderBitmapTileSubLayer } from './renderBitmapTileSubLayer';

export const quadkeyTileYears = {
  bingAerial:
    'http://ecn.t0.tiles.virtualearth.net/tiles/r{quadkey}.jpeg?g=6644&mkt=cs-CZ&shading=hill',
};

type AerialYears = keyof typeof quadkeyTileYears;
type YearUrls = typeof quadkeyTileYears[AerialYears];

const toQuadKey = (x: number, y: number, z: number) => {
  var index = '';
  for (var i = z; i > 0; i--) {
    var b = 0;
    var mask = 1 << (i - 1);
    if ((x & mask) !== 0) b++;
    if ((y & mask) !== 0) b += 2;
    index += b.toString();
  }
  return index;
};

export const quadkeyTileLayer = (
  year: YearUrls = quadkeyTileYears.bingAerial
) =>
  new TileLayer({
    id: 'quadkey-tile-layer',
    getTileData: async ({ index: { x, y, z }}) => {
      const url = `https://ecn.t3.tiles.virtualearth.net/tiles/a${toQuadKey(x, y, z)}.jpeg?g=1`;
      const result = await fetch(url);
      const data = await parse(result);
      return data;
    },
    loadOptions: {
      mimeType: 'image/jpeg',
      fetch: {
        mode: 'cors'
      },
    },
    maxRequests: 17,
    pickable: true,
    highlightColor: [60, 60, 60, 40],
    minZoom: 1,
    maxZoom: 21,
    tileSize: 256,
    opacity: 1,
    renderSubLayers: renderBitmapTileSubLayer,
  });
